import axios from "axios";
import { urlBaseAccreditation } from './../../config/index';

export default async function deleteEventUserApi(
  token = '',
  userId = '',
) {
  try {
    const options = {
      url: `${urlBaseAccreditation}/mobileUser/deleteMobileUser?id=${userId}`,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `bearer ${token}`
      },
    };
    await axios(options);

    return;
  } catch (error) {
    console.log('Error deleteEventUserApi', error);
    throw error;
  }
}
